var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.64862 5.29724C4.11141 5.29724 5.29724 4.11141 5.29724 2.64862C5.29724 1.18583 4.11141 0 2.64862 0C1.18583 0 0 1.18583 0 2.64862C0 4.11141 1.18583 5.29724 2.64862 5.29724Z","fill":"white","key":0}),React.createElement("path",{"d":"M7.79806 7.30426V21.9988H12.3605V14.732C12.3605 12.8145 12.7212 10.9576 15.0987 10.9576C17.4435 10.9576 17.4725 13.1499 17.4725 14.8531V22H22.0374V13.9415C22.0374 9.98314 21.1852 6.9411 16.5586 6.9411C14.3373 6.9411 12.8483 8.1601 12.2395 9.31372H12.1777V7.30426H7.79806ZM0.363037 7.30426H4.93275V21.9988H0.363037V7.30426Z","fill":"white","key":1})]);
}

Linkedin.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
